<template>
  <div class="flex">
    <sidebar :routes="sidebarRoutes" />
    <main-container>
      <router-view />
      <pagination-buttons :pages="pages"></pagination-buttons>
    </main-container>
  </div>
</template>

<script>
const Sidebar = () =>
  import(/* webpackChunkName: "SidebarComponent" */ "@/components/Global/Sidebar");
const MainContainer = () =>
  import(/* webpackChunkName: "MainContainerComponent" */ "@/components/Global/MainContainer.vue");
const PaginationButtons = () =>
  import(/* webpackChunkName: "PaginationButtons" */ "@/components/Global/PaginationButtons.vue");

export default {
  name: "AboutMe",
  components: {
    Sidebar,
    MainContainer,
    PaginationButtons
  },
  computed: {
    /*
     * @computed - pages
     * Array of pages href names that will be passed to pagination buttons component
     */
    pages() {
      return this.sidebarRoutes.map(route => route.href);
    },
    /*
     * @computed - sidebarRoutes
     * Data required for each route on the sidebar component
     */
    sidebarRoutes() {
      return [
        {
          description: this.$t("aboutMe.abstract.pageLabel"),
          icon: ["fas", "id-card-alt"],
          href: "AboutMeAbstract"
        },
        {
          description: this.$t("aboutMe.workExperience.pageLabel"),
          icon: ["fas", "user-tie"],
          href: "WorkExperience"
        },
        {
          description: this.$t("aboutMe.abilities.pageLabel"),
          icon: ["fas", "clipboard-list"],
          href: "Abilities"
        },
        {
          description: this.$t("aboutMe.courses.pageLabel"),
          icon: ["fas", "book-reader"],
          href: "Courses"
        },
        {
          description: this.$t("aboutMe.education.pageLabel"),
          icon: ["fas", "user-graduate"],
          href: "Education"
        },
        {
          description: this.$t("aboutMe.otherMerits.pageLabel"),
          icon: ["fas", "scroll"],
          href: "OtherMerits"
        }
      ];
    }
  }
};
</script>
